module.exports = __webpack_public_path__ + "static/media/image15.351c4c9b.png";